export const MISSION_TARGET_TYPES = ['sessionsStarted', 'minutesLearned'] as const;
export type MissionTargetType = (typeof MISSION_TARGET_TYPES)[number];

export interface DailyMissionTemplate {
  id: string;
  title: string;
  targetType: MissionTargetType;
  targetValue: number;
  order: number;
  isActive: boolean;
}

export interface LevelDefinition {
  id: string;
  level: number;
  title: string;
  minPoints: number;
}
